import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAdminStore } from "@/features/auth/stores/adminStore";
import { Button, Card, CardContent } from "@/shared/components/ui";
import { Shield, AlertCircle } from "lucide-react";

export function AdminLoginPage() {
  const navigate = useNavigate();
  const { login, isLoading, error, clearError } = useAdminStore();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    clearError();

    try {
      await login(email, password);
      navigate("/admin");
    } catch {
      // Error is handled by the store
    }
  };

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-primary-600 rounded-full mb-4">
            <Shield className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-3xl font-bold text-white">Panel Administratora</h1>
          <p className="text-gray-400 mt-2">Zaloguj się do panelu administracyjnego</p>
        </div>

        <Card className="bg-gray-800 border-gray-700">
          <CardContent className="p-6">
            <form onSubmit={handleSubmit} className="space-y-4">
              {error && (
                <div className="p-3 bg-error-900/50 border border-error-700 rounded-lg flex items-start gap-2">
                  <AlertCircle className="w-5 h-5 text-error-400 flex-shrink-0 mt-0.5" />
                  <p className="text-sm text-error-300">{error}</p>
                </div>
              )}

              <div>
                <label className="block text-sm font-medium text-gray-300 mb-1.5">
                  Email
                </label>
                <input
                  type="email"
                  placeholder="admin@zaem.pl"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoComplete="email"
                  className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded-lg text-white placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-300 mb-1.5">
                  Hasło
                </label>
                <input
                  type="password"
                  placeholder="••••••••"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  autoComplete="current-password"
                  className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded-lg text-white placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                />
              </div>

              <Button
                type="submit"
                className="w-full"
                isLoading={isLoading}
                leftIcon={<Shield className="w-4 h-4" />}
              >
                Zaloguj jako administrator
              </Button>
            </form>
          </CardContent>
        </Card>

        <p className="mt-6 text-center text-sm text-gray-500">
          <Link to="/login" className="hover:text-gray-400">
            Panel doradcy
          </Link>
        </p>
      </div>
    </div>
  );
}
